import { Controller, useForm } from 'react-hook-form';

import { useOnboardingContext } from '@/contexts/onboardingContext';
import useTranslate from '@/hooks/useTranslate';
import { STEPS_PATH_TRANSLATION_KEY } from '@/pages/members/pages/Onboarding/constants';
import StepComponent from '@/pages/members/pages/Onboarding/steps/StepComponent';
import FieldError from '@/ui/members/components/form/FieldError';
import InputGroup from '@/ui/members/components/form/InputGroup';
import PasswordInput from '@/ui/members/components/form/PasswordInput';
import Heading from '@/ui/members/components/typography/Heading';

import getSubmittedData from '../../utils/getSubmittedData';
import { StepProps } from '../types';

import { PasswordFormValues } from './types';

const MIN_LENGTH = 8;

const PasswordStep = ({ nodeType, uid }: StepProps) => {
  const onboardingContext = useOnboardingContext();
  const { t } = useTranslate(`${STEPS_PATH_TRANSLATION_KEY}.PasswordStep`);

  const {
    control,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<PasswordFormValues>({
    mode: 'onSubmit',
    defaultValues: (getSubmittedData(
      nodeType,
      uid,
      onboardingContext.steps
    ) as PasswordFormValues) || {
      password: ''
    }
  });

  return (
    <StepComponent uid={uid} nodeType={nodeType} handleSubmit={handleSubmit} isValid={isValid}>
      <div className="text-center mb-6">
        <Heading className="mb-3" value={1}>
          {t('finishYourAccount')}
        </Heading>

        <p className="text-base mb-3">{t('enterAPassword')}</p>
      </div>

      <InputGroup>
        <Controller
          defaultValue=""
          name="password"
          control={control}
          rules={{
            required: t('passwordIsRequired'),
            minLength: {
              value: MIN_LENGTH,
              message: t('passwordMinLength')
            },
            validate: (value) => {
              if (/\s/.test(value)) {
                return t('passwordNoSpaces');
              }
              return true;
            }
          }}
          render={({ field }) => (
            <PasswordInput autoFocus onChange={field.onChange} placeholder="" value={field.value} />
          )}
        />

        <FieldError error={errors.password} />
      </InputGroup>
    </StepComponent>
  );
};

export default PasswordStep;
